module.exports = __webpack_public_path__ + "static/media/logo.307fe3a8.png";